import { useState, useEffect, useCallback } from "react";
import { UIContext } from "@/context/UIContext";

export function UIProvider({ children }: { children: React.ReactNode }) {
  // Dark Mode
  const [darkMode, setDarkMode_] = useState<boolean>(() => {
    const lsDarkMode = localStorage.getItem("darkMode");
    if (!lsDarkMode) {
      return window?.matchMedia?.("(prefers-color-scheme:dark)")?.matches ?? false;
    }
    return lsDarkMode === "true";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", darkMode ? "dark" : "light");
  }, [darkMode]);

  const setDarkMode = useCallback((value: boolean) => {
    setDarkMode_(value);
    localStorage.setItem("darkMode", String(value));
  }, []);

  // Animations
  const [animated, setAnimated_] = useState<Record<string, boolean>>({});

  function getAnimated(key: string) {
    return animated[key] || false;
  }

  function setAnimated(key: string) {
    setAnimated_((a) => ({ ...a, [key]: true }));
  }

  function unsetAnimated(key: string) {
    setAnimated_((a) => ({ ...a, [key]: false }));
  }

  return (
    <UIContext.Provider
      value={{
        darkMode,
        setDarkMode,
        animated,
        getAnimated,
        setAnimated,
        unsetAnimated,
      }}
    >
      {children}
    </UIContext.Provider>
  );
}
